import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/cms`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const ttbApi = {
  postTransferMultiTicket: (request) => {
    const { data } = request
    return instance().post(`/tranfer-multi-ticket`, data)
  },
  postRealTimePerformance: (request) => {
    const { data } = request
    // {
    //   date: String // today YYYY-MM-DD
    //   page_id: String
    // }
    return instance().post(`/real-time-performance`, data)
  },
  getTicketCardCounts: (request) => {
    const { params } = request
    // pageid
    // startTime
    // endTime
    // role
    // channel
    // search_page_id
    return instance().get(`/ticket-card-counts`, {
      params,
      baseURL: `${config.serverUrl}commonnewticket/cms`
    })
  },
  postChatlogCountAgentBot: (request) => {
    const { data } = request
    // "page_id": "116388304732570",
    // "start_date": "2022-08-31",
    // "end_date": "2023-08-31",
    // "search_page_id": "116388304732570",
    // "channel": "facebook"
    return instance().post(`/chatlog-count-agent-bot`, data, {
      baseURL: `${config.serverUrl}commonnewticket/cms`
    })
  },
  postAverageResponseTime: (request) => {
    const { data } = request
    // "page_id": "116388304732570",
    // "start_date": "2022-08-31",
    // "end_date": "2023-08-31",
    // "search_page_id": "116388304732570",
    // "channel": "facebook"
    return instance().post(`/average-response-time`, data, {
      baseURL: `${config.serverUrl}commonnewticket/cms`
    })
  },
  getTopQuestion: (request) => {
    const { params } = request
    // page_id
    // limit
    // offset
    return instance().get(`/top-question`, {
      params,
      baseURL: `${config.serverUrl}commonnewticket/cms`
    })
  },
  getTopWrapUp: (request) => {
    const { params } = request
    return instance().get(`/top-wrap-up`, {
      params,
      baseURL: `${config.serverUrl}commonnewticket/cms`
    })
  },
  getCountCommentAndSentiment: (request) => {
    const { params } = request
    // page_id
    // start_date
    // end_date
    // search_page_id
    return instance().get(`/count-comment-and-sentiment`, {
      params
    })
  },
  getSentimentByUser: (request) => {
    const { params } = request
    // page_id
    // start_date
    // end_date
    // search_page_id
    // limit
    // offset
    // sentiment
    // name
    // all_nagative
    return instance().get(`/get-sentiment-by-user`, {
      params
    })
  },
  getSentimentByUserId: (request) => {
    const { params, userid } = request
    // page_id
    // limit
    // offset
    return instance().get(`/sentiment/${userid}`, {
      params
    })
  },
  patchSentiment: (request) => {
    const { data, sentimentId } = request
    // {
    //     "page_id": "116388304732570",
    //     "remark": "test",
    //     "sentiment": "nagative",
    //     "checkbox": false
    // }
    return instance().patch(`/sentiment/${sentimentId}`, data)
  },
  postGetTicketSurvey: (request) => {
    const { data } = request
    return instance().post(`/ticket/survey`, data)
  },
  getChildPage: (request) => {
    const { pageId } = request
    return instance().get(`/child-page/${pageId}`)
  },
  getCountTicketClosedByAgent: (request) => {
    const { params } = request
    return instance().get(`/count-ticket-assign-closed`, {
      params
    })
  },
  getCountTicketStatusByAgent: (request) => {
    const { params } = request
    return instance().get(`/count-ticket-status-by-agent`, {
      params
    })
  },
  getAgentWorkTime: (request) => {
    const { params } = request
    return instance().get(`/agent-work-time`, {
      params
    })
  },
  getAgentCheckInCheckOutByAdminId: (request) => {
    const { params } = request
    return instance().get(`/checkIncheckOutStatByAdminId`, {
      params
    })
  },
  getCountAgentOnlineOffline: (request) => {
    const { params } = request
    return instance().get(`/count-admin-status-check-in-check-out`, {
      params
    })
  },
  getReportOverview: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    return instance().get(`/report/overview`, {
      params
    })
  },
  getReportProductivity: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    //select_type
    return instance().get(`/report/product-activity`, {
      params
    })
  },
  getReportPerformanceNonvoice: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    return instance().get(`/report/performence-non-voice`, {
      params
    })
  },
  getReportSlByAgentInterval: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    return instance().get(`/report/sl-by-agent-interval`, {
      params
    })
  },
  getReportProductivityInterval: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    //select_type
    return instance().get(`/report/product-activity-interval`, {
      params
    })
  },
  getReportSummaryStaffPerformance: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    //select_type
    //agent
    return instance().get(`/report/summary-staff-performance`, {
      params
    })
  },
  getReportSummaryStaffPerformanceByAgent: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    return instance().get(`/report/summary-staff-performance-by-agent`, {
      params
    })
  },
  getReportCloseCaseByChannel: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    return instance().get(`/report/close-case-by-channel`, {
      params
    })
  },
  getReportCaseByStatus: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    return instance().get(`/report/case-by-status`, {
      params
    })
  },
  getReportCaseByProduct: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    return instance().get(`/report/case-by-product`, {
      params
    })
  },
  getReportCloseCaseByWrapUp: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    return instance().get(`/report/close-case-by-wrap-up`, {
      params
    })
  },
  getReportCloseCaseByWebPage: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    return instance().get(`/report/close-case-by-web-page`, {
      params
    })
  },
  getReportSurvey: (request) => {
    const { params } = request
    // page_id
    // select_page_id
    // channel
    // date_from
    // date_to
    return instance().get(`/report/survey`, {
      params
    })
  },
  getReportTransectionByAgent: (option) => {
    return instance().get(`/report/agent-reply-message`, option)
  }
}
export default ttbApi



// WEBPACK FOOTER //
// ./src/api/ttb.js